/* eslint-disable max-len */
/* eslint-disable no-console */
/* eslint-disable react/jsx-closing-bracket-location */
import React, { useEffect, useState, useCallback, memo, useContext } from 'react';
import { Card, Grid, keyframes } from '@mui/material';
import FeedHeader from './FeedHeader';
import { useParams } from 'react-router-dom';
import FeedFooter from './FeedFooter';
import FeedBody from './FeedBody';
import { feedActionContext } from '../../../..';
import ApprovalStatus from './ApprovalStatus';

const blinkAnimation = keyframes`
  0%, 100% {
    border-color: #D6EDD7; /* Original color */
  }
  50% {
    border-color: transparent; /* Blink effect */
  }`;

const FeedCard = (props) =>
{
	// from  'business_profile' | 'network_profile' | 'my_profile' | 'repost' need to hide footer
	const { item, index, delCloseGetApi, from = '', noAction, requestT, contextT, selectedActivity, handleEditedFeedUpdate } = props;
	const type = useParams()?.type ?? 'feeds';
	const { feedCardActn, feedAction } = useContext(feedActionContext);
	const isBookmarks = type === 'bookmarks';
	const [ feed, setFeed ] = useState<any>((isBookmarks && from !== 'repost') ? (item?.feed?.[0] || {}) : item); // use this to map any data
	const isFeedPendingOrRejected = [ 'pending', 'rejected' ].includes(feed.status);
	const hideFooter = [ 'repost' ].includes(from) || isFeedPendingOrRejected; // previosly it was type !== draft condition, now removed it because in drafts we dont need to show main post footer, if it is there, displaying duplicate footers

	useEffect(() =>
	{
		// when item data updated but feed data still contain old then...
		if (JSON.stringify(feed) !== JSON.stringify(item))
		{
			setFeed(isBookmarks ? (item?.feed?.[0] || {}) : item);
		}
	}, [ item?.feed, item?.bookMark, item?.selfLike, item?.repostCount ]);

	// Updating the comments count in the feed card
	useEffect(() =>
	{
		if (Number.isInteger(feedAction?.comments_add))
		{
			const id = feedCardActn[1]?._id;

			if (feed?._id === id) setFeed({ ...feed, commentsCount: Number(feedAction?.comments_add) });
		}
	}, [ feedAction?.comments_add ]);

	const handleUpdateFeed = useCallback((updateObj) =>
	{
		setFeed((prev) => ({ ...prev, ...updateObj }));
		handleEditedFeedUpdate && handleEditedFeedUpdate(updateObj);
	}, []);

	if (!item?._id && from !== 'repost')
	{
		return (<></>);
	}

	return (
		<Grid id={feed?._id} container p={from === 'repost' ? '0px !important' : ''} pb={from === 'repost' ? ' 0px !important' : 'var(--pixel16)'} xs={12} item> {/* Add `item` here */}
			{item && (
				<Card
					sx={{
						width        : 'var(--percent100)',
						p            : from === 'repost' ? '10px 0px' : '20px 20px 8px 20px',
						border       : item?.type === 'all' ? '5px solid var(--joinLive)' : '',
						boxShadow    : from === 'repost' ? 'none' : '0 2px 5px var(--boxshadow0-5)',
						borderRadius : 'var(--pixel13)',
						animation    : item?.type === 'all' ? `${blinkAnimation} 1.5s ease-in-out infinite` : 'none'
					}}
				>
					<Grid item xs={12}>
						<FeedHeader
							feed={feed}
							delCloseGetApi={delCloseGetApi}
							handleUpdateFeed={handleUpdateFeed}
							index={index}
							from={from}
							contextT={contextT}
							requestT={requestT}
						/>
					</Grid>
					<Grid item xs={12}>
						<FeedBody
							feed={feed}
							type={type}
							handleUpdateFeed={handleUpdateFeed}
							selectedActivity={selectedActivity}
							noAction={noAction}
							from={from}
						/>
					</Grid>
					{/* Approval Status Section */}
					{isFeedPendingOrRejected && (
						<Grid item xs={12} sx={{ mt: 2, mb: 1 }}>
							<ApprovalStatus feed={feed} handleUpdateFeed={handleUpdateFeed} />
						</Grid>
					)}

					{/* Footer Section - Hide for pending feeds */}
					{!hideFooter && (
						<Grid item xs={12}>
							<FeedFooter
								key={[ feed?._id, feed?.repostCount ]}
								feed={feed}
								eachType={feed.type}
								feedId={feed?._id}
								requestT={requestT}
								delCloseGetApi={delCloseGetApi}
							/>
						</Grid>
					)}
				</Card>
			)}
		</Grid>
	);
};

export default memo(FeedCard);